import { render } from "./LeftSidebarLayout.vue?vue&type=template&id=4d2b356c"
import script from "./LeftSidebarLayout.vue?vue&type=script&lang=js"
export * from "./LeftSidebarLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/instructor/LeftSidebarLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d2b356c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d2b356c', __exports__)) {
    api.reload('4d2b356c', __exports__)
  }
  
  module.hot.accept("./LeftSidebarLayout.vue?vue&type=template&id=4d2b356c", () => {
    api.rerender('4d2b356c', render)
  })

}


export default __exports__